import "./LandingPage.css";

export default function LandingPage(){
  
  return <div className="aboutPage" id="home" >
    <div className="wrapper">
      {/* <h2 className="hi">Hii</h2> */}
      <h1 className="name">Juan Sanchez</h1>
  <h2 className="quote">There is an easy way and a hard way. The hard part is finding the easy way</h2>
  <h2  className="greeting">Lorem Ipsum  </h2>

  
  </div>
  </div>
}